<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="text-end mb-2">
        <soft-button color="info" size="lg" @click="btn_time_entry">
          Time Entry
        </soft-button>
      </div>

      <!-- DATE RANGE FILTER -->
      <div class="text-start mb-2 d-flex align-items-center">
        <label class="me-2">From:</label>
        <input
          type="date"
          v-model="fromDate"
          class="me-3"
          @change="filterByDateRange"
        />

        <label class="me-2">To:</label>
        <input
          type="date"
          v-model="toDate"
          class="me-3"
          @change="filterByDateRange"
        />

        <soft-button color="danger" size="sm" @click="resetFilter">
          Clear Filter
        </soft-button>
      </div>
    </div>

    <!-- TABLE -->
    <div class="row">
      <div class="col-12">
        <table class="table align-items-center justify-content-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Client
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Time In
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Time Out
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Total Hours
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Specifications
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7 ps-2"
              >
                Status
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7 ps-2"
              >
                Payroll Status
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="timesheet in filteredTimesheets" :key="timesheet.id">
              <td>
                <h6 class="mb-0 text-sm">
                  <b
                    >{{ timesheet.client.first_name }}
                    {{ timesheet.client.last_name }}</b
                  >
                </h6>
              </td>
              <td>
                <p class="mb-0 text-sm">
                  {{ timesheet.start_date }} {{ timesheet.start_time }}
                </p>
              </td>
              <td>
                <p class="mb-0 text-sm">
                  {{ timesheet.end_date }} {{ timesheet.end_time }}
                </p>
              </td>
              <td>
                <p class="mb-0 text-sm">{{ timesheet.total_hours }}</p>
              </td>
              <td>
                <span class="text-xs font-weight-bold">{{
                  timesheet.specification ?? "No specifications"
                }}</span>
              </td>
              <td class="align-middle text-center">
                <span
                  class="text-xs font-weight-bold"
                  v-if="timesheet.status == 0"
                  >Pending</span
                >
                <span
                  class="text-xs font-weight-bold text-success"
                  v-else-if="timesheet.status == 1"
                  >Approved</span
                >
                <span class="text-xs font-weight-bold text-danger" v-else
                  >Declined</span
                >
              </td>
              <td>
                <p class="mb-0 text-sm text-right">
                  {{ timesheet.payroll_status }}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <modal :is-open="isModalOpen" @close="closeModal" />
  </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
import Modal from "@/views/components/time_entry_modal.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "TimesheetTable",
  components: {
    SoftButton,
    Modal,
  },
  data() {
    return {
      isModalOpen: false,
      timesheets: [],
      filteredTimesheets: [],
      fromDate: "",
      toDate: "",
    };
  },
  methods: {
    btn_time_entry() {
      if (!localStorage.getItem("selectedClientId")) {
        return Swal.fire({
          icon: "error",
          title: "Oops...",
          text: `Please select a client before time entry.`,
        });
      }
      this.isModalOpen = true;
    },

    closeModal() {
      this.isModalOpen = false;
      this.fetch_timesheets();
    },

    async fetch_timesheets() {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/timesheets`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        this.timesheets = response.data.data;
        this.filteredTimesheets = this.timesheets;
      } catch (error) {
        console.error("Error fetching timesheets:", error);
      }
    },

    filterByDateRange() {
      if (!this.fromDate && !this.toDate) {
        this.filteredTimesheets = this.timesheets;
        return;
      }

      const from = this.fromDate ? new Date(this.fromDate) : null;
      const to = this.toDate ? new Date(this.toDate) : null;

      this.filteredTimesheets = this.timesheets.filter((t) => {
        const startDate = new Date(t.start_date);
        const endDate = new Date(t.end_date);

        // Inclusive range filter
        const afterFrom = !from || startDate >= from || endDate >= from;
        const beforeTo = !to || startDate <= to || endDate <= to;

        return afterFrom && beforeTo;
      });
    },

    resetFilter() {
      this.fromDate = "";
      this.toDate = "";
      this.filteredTimesheets = this.timesheets;
    },
  },

  mounted() {
    this.fetch_timesheets();
  },
};
</script>
